
/* injects from baggage-loader */

'use strict';

export default function (app) {

	// NOTE: TEMPALTE REPLACEMENT HANDLED BY WEBPACK, DON'T EDIT MANUALLY
	// Default page name displayed in the browser tab
	app.constant('DEFAULT_PAGE_TITLE', 'Historic Funds');

	// NOTE: TEMPALTE REPLACEMENT HANDLED BY WEBPACK, DON'T EDIT MANUALLY
	// Map tile server
	app.constant('MAP_TILE_SERVER', 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}')
	
}


// WEBPACK FOOTER //
// ./src/app/core/constants.js